import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import EmployeeApi from './employeeApi';
import { Employee } from './employeeType';
import HorizontalMenu from '../components/common/horizontalMenu';
import Breadcrumbs from '../components/common/breadcrumbs';
import { Trash } from 'lucide-react';
import { formatDate } from '../lib/global_function';
import { Button } from '../components/ui/button';
import { Alert } from '../components/ui/alert';

const DeleteEmployeePage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Company', path: '/main/company' },
    { label: 'Employee', path: '/main/company/employee' },
    { label: 'Delete', path: '/main/company/employee/delete' },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const employee = location.state?.selectedEmployee as Employee;
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleDelete = async () => {
    try {
      await EmployeeApi.delete(employee.employee_id!);
      navigate('/main/company/employee', { state: { message: 'Employee deleted successfully.' } });
    } catch (error) {
      setErrorMessage(error instanceof Error ? error.message : 'An unknown error occurred.');
    }
  };

  return (
    <>
      <HorizontalMenu />
      <div className="container-safe py-6">
        <Breadcrumbs items={breadcrumbs} />

        <h2 className="text-2xl font-bold text-foreground mt-6 mb-4">Delete Employee</h2>

        {errorMessage && (
          <Alert variant="error">
            {errorMessage}
          </Alert>
        )}

        <p className="text-base text-foreground mb-6">
          Are you sure you want to delete the following employee?
        </p>

<div className="bg-white rounded-2xl mb-6 border-2 border-muted p-6 shadow-card">
          <div>
            <strong className="text-foreground font-semibold">Name:</strong>{' '}
            <span className="text-foreground">{employee.first_name} {employee.last_name}</span>
          </div>

          <div>
            <strong className="text-foreground font-semibold">Employee Code:</strong>{' '}
            <span className="text-foreground">{employee.employee_code}</span>
          </div>

          <div>
            <strong className="text-foreground font-semibold">Email:</strong>{' '}
            <span className="text-foreground">{employee.email}</span>
          </div>

          <div>
            <strong className="text-foreground font-semibold">Phone:</strong>{' '}
            <span className="text-foreground">{employee.phone}</span>
          </div>

          <div>
            <strong className="text-foreground font-semibold">Type:</strong>{' '}
            <span className="text-foreground">{employee.employee_type}</span>
          </div>

          <div>
            <strong className="text-foreground font-semibold">Title:</strong>{' '}
            <span className="text-foreground">{employee.employee_title}</span>
          </div>

          <div>
            <strong className="text-foreground font-semibold">Start Date:</strong>{' '}
            <span className="text-foreground">
              {employee.start_date ? formatDate(employee.start_date) : 'N/A'}
            </span>
          </div>
        </div>

        <Button
          onClick={handleDelete}
          size="medium"
          
        >
          <Trash className="size-5" />
          Delete Employee
        </Button>

        <div className="mb-[150px]"></div>
      </div>
    </>
  );
};

export default DeleteEmployeePage;